import axios from "axios";
import { ISearchData } from "types";
import { ISearchResults } from "types";

export class SearchService {
  static search = (data: ISearchData): Promise<ISearchResults> =>
    new Promise(async (resolve, reject) => {
      try {
        const request = await axios.get("/search/json", {
          params: {
            q: data.query,
            facets: data.facets,
            page: data.page - 1,
            a: data.amount,
            sortBy: data.sortBy,
          },
        });

        if (request.data.err) {
          return reject({
            error: request.data.err,
          });
        }

        resolve(request.data as ISearchResults);
      } catch (error: any) {
        reject({
          error: error.response?.statusText,
        });
      }
    });
}
